import _objectSpread from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _createClass from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _classCallCheck from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

/** Represents an HTTP response. */
export var HttpResponse = function HttpResponse(statusCode, statusText, content) {
  _classCallCheck(this, HttpResponse);

  this.statusCode = statusCode;
  this.statusText = statusText;
  this.content = content;
};
/** Abstraction over an HTTP client.
 *
 * This class provides an abstraction over an HTTP client so that a different implementation can be provided on different platforms.
 */

export var HttpClient =
/*#__PURE__*/
function () {
  function HttpClient() {
    _classCallCheck(this, HttpClient);
  }

  _createClass(HttpClient, [{
    key: "get",
    value: function get(url, options) {
      return this.send(_objectSpread({}, options, {
        method: "GET",
        url: url
      }));
    }
  }, {
    key: "post",
    value: function post(url, options) {
      return this.send(_objectSpread({}, options, {
        method: "POST",
        url: url
      }));
    }
  }, {
    key: "delete",
    value: function _delete(url, options) {
      return this.send(_objectSpread({}, options, {
        method: "DELETE",
        url: url
      }));
    }
    /** Gets all cookies that apply to the specified URL.
     *
     * @param url The URL that the cookies are valid for.
     * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
     */
    // @ts-ignore

  }, {
    key: "getCookieString",
    value: function getCookieString(url) {
      return "";
    }
  }]);

  return HttpClient;
}();